import { Pagination } from './Pagination'

export class Token {
  accessToken = "";
  expiredAt = 0
  requireChangePassword = false;

  constructor(fields: Token) {
    Object.assign(this, fields);
  }
}

export class Account {
  public id?: number
  public email?: string
  public role?: string
  public accessMenu?: string
  public accessMenus?: AccessMenu[]
  public isLogin2faEnabled?: boolean
  public isLogin2faEnrolled?: boolean

  constructor(
    id?: number,
    email?: string,
    role?: string,
    accessMenu?: string,
    accessMenus?: AccessMenu[],
    isLogin2faEnabled?: boolean,
    isLogin2faEnrolled?: boolean
  ) {
    this.id = id
    this.email = email
    this.role = role
    this.accessMenu = accessMenu
    this.accessMenus = accessMenus
    this.isLogin2faEnabled = isLogin2faEnabled
    this.isLogin2faEnrolled = isLogin2faEnrolled
  }
}

export class Role {
  public role?: string

  constructor(role?: string) {
    this.role = role
  }
}

export class AccessMenu {
  public id?: number
  public slug?: string
  public name?: string
  public group?: string
  public isGranted?: boolean

  constructor(
    id?: number,
    slug?: string,
    name?: string,
    group?: string,
    isGranted?: boolean
  ) {
    this.id = id
    this.slug = slug
    this.name = name
    this.group = group
    this.isGranted = isGranted
  }
}

export class Accounts {
  public pagination?: Pagination
  public data?: Account[]

  constructor(pagination?: Pagination, data?: Account[]) {
    this.pagination = pagination
    this.data = data
  }
}

export class OTP {
  email = "";
  otpId = 0;
  expiredIn = 120;

  constructor(fields: OTP) {
    Object.assign(this, fields);
  }
}

export class Token2FAEnrollment {
  enrolled = false;
  setupRequired = false;

  constructor(fields?: Partial<Token2FAEnrollment>) {
    Object.assign(this, fields);
  }
}

export class Token2FA {
  otpRequired = false;
  challengeToken = "";
  expiresAt = "";
  enrollment = new Token2FAEnrollment();

  constructor(fields?: Partial<Token2FA>) {
    Object.assign(this, fields)
  }
}

export class TwoFactorAuthLogin {
  authentication: Token | null = null;
  twoFactorAuth = new Token2FA();

  constructor(fields?: Partial<TwoFactorAuthLogin>) {
    Object.assign(this, fields);
  }
}

export class OTP2FA {
  otpId = 0;
  expiredIn = 0;
  expiredAt = "";
  cooldownIn = 0;
  username = "";

  constructor(fields?: Partial<OTP2FA>) {
    Object.assign(this, fields);
  }
}  
export interface ProfileMfaOtpResponse {
  otpId: number
  username: string
  expiredIn: number
  cooldownIn: number
  expiredAt: string
}
export interface ProfileMfaOtpResponse {
  otpId: number
  username: string
  expiredIn: number
  cooldownIn: number
  expiredAt: string
}

